(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kd-marquee"] && !Shopify.designMode) return;
  try {
    
  // Freeze the wall while it is being touched or pointed at, so a tile can be
  // pressed accurately. Pausing is done on the ELEMENT, not by swapping a
  // class, because these are long linear animations and a class change that
  // restarted them would make the wall jump.
  document.querySelectorAll('.kd-marq').forEach((wall) => {
    const tracks = wall.querySelectorAll('.kd-marq__track');
    const stage = wall.querySelector('.kd-marq__stage');
    if (!tracks.length || !stage) return;

    let timer = null;
    const set = (state) => tracks.forEach((t) => { t.style.animationPlayState = state; });
    const hold = () => { clearTimeout(timer); set('paused'); };
    // Half a second, so a tap that turns out to be a scroll does not leave the
    // wall frozen, and a real tap has finished navigating before it moves.
    const release = () => { clearTimeout(timer); timer = setTimeout(() => set('running'), 500); };

    stage.addEventListener('pointerdown', hold);
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);
    // Mouse only. A hover pause on touch would never resume, because touch
    // devices leave the pointer "over" the last thing it touched.
    stage.addEventListener('pointerover', (e) => { if (e.pointerType === 'mouse') hold(); });
    stage.addEventListener('pointerout', (e) => { if (e.pointerType === 'mouse') release(); });
    // A dragged finger is a scroll, not a press: let the wall run again.
    stage.addEventListener('touchmove', release, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Scroll-reveal for product cards (2026-08-29): cards rise+fade in as
  // they enter the viewport, staggered per batch. The hiding class is
  // only added from JS so a script failure never leaves cards invisible;
  // infinite-scroll and filter morphs are picked up by the MutationObserver.
  document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('.product-grid-container');
    if (!grid || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    grid.classList.add('kd-reveal');
    const io = new IntersectionObserver(
      (entries) => {
        let batch = 0;
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          e.target.style.setProperty('--kd-d', Math.min(batch++, 8));
          e.target.classList.add('kd-in');
          io.unobserve(e.target);
        }
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
    );
    const watch = () => {
      grid.querySelectorAll('.product-grid__item:not([data-kd-obs])').forEach((el) => {
        el.dataset.kdObs = '1';
        io.observe(el);
      });
    };
    watch();
    new MutationObserver(watch).observe(grid, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();
})();
